<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string;
  }>(),
  {}
);
</script>

<template>
  <button
    v-bind="$attrs"
    class="ia-button border-0 d-flex align-items-center justify-content-center gap-2 rounded"
    :class="{ 'aspect-ratio-1': !label?.length }"
  >
    <i class="bi-stars" :style="`font-size: 16px`"></i>
    <span v-if="label" class="small fw-medium">{{ label }}</span>
  </button>
</template>

<style lang="scss" scoped>
@import "@/style/variables.scss";
.ia-button {
  color: var(--bs-ia);
  font-size: 12px;
  background-color: transparent;
  border: 1px solid rgba($ia, 0.1);
  transition: all 0.2s ease;
  &:hover {
    background-color: $ia;
    color: white;
  }
}
</style>
